import React, {
  ReactElement,
  useEffect,
  useState,
} from 'react';
import { Entity } from '../../types/entities/Entity';
import { Schema } from '../../types/Schema';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import api from '../../services/api';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';

type Props<T extends Entity> = {
  onClose: (item: boolean) => void;
  values: any;
  type: string;
};

export const SendModification = <T extends Entity>({
  type,
  values,
  onClose,
}: Props<T>): ReactElement => {
  const [modifications, setModifications] = useState<any>([]);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps['maxWidth']>('md');
  const [state, setState] = React.useState({ 0: false, 1: false });

  const handleClose = () => {
    onClose(false);
  };

  const handleCloseSnackBar = (action: number) => {
    setState({ ...state, [`${action}`]: true });
  };

  const handleSubmit = () => {
    setLoading(true);

    api
      .post(`/service-reservation-modifications`, {
        data: modifications,
      })
      .then((res: any) => {
        setLoading(false);
        setState({ ...state, [0]: true });
        handleClose();
      })
      .catch((error) => {
        setState({ ...state, [1]: true });
      });
  };

  useEffect(() => {
    const typeForGet = type === 'service' ? '' : `-${type}`;

    if (type === 'all') {
      const searchParams = new URLSearchParams({
        ids: values,
      });
      api
        .get(`/service-reservation-modifications-all`, searchParams)
        .then((res: any) => {
          setModifications(res);
        });
    } else {
      api
        .get(`/service-reservation-modifications${typeForGet}/${values?.id}`)
        .then((res: any) => {
          setModifications(res);
        });
    }
  }, []);

  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Modifications
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {modifications.map((item: any, index: number) => {
            return (
             /* <SendModificationListItem
                item={item}
                index={index}
                onChange={(value) => {
                  const newModifications = modifications.filter(
                    (modificationItem: any) => {
                      if (modificationItem?.id === item?.id) {
                        modificationItem['send'] = value;
                      }
                      return modificationItem;
                    }
                  );

                  console.log(newModifications);
                }}
              />*/
              <></>
            );
          })}
        </DialogContent>
        <DialogActions>
          <Box sx={{ position: 'relative' }}>
            <Button autoFocus disabled={loading} onClick={handleSubmit}>
              Send Modifications
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: '#000',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  marginTop: '-12px',
                  marginLeft: '-12px',
                }}
              />
            )}
          </Box>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={state[0]}
        onClose={() => handleCloseSnackBar(0)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={5000}
      >
        <Alert
          onClose={() => handleCloseSnackBar(0)}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Successfully sended notifications
        </Alert>
      </Snackbar>

      <Snackbar
        open={state[1]}
        onClose={() => handleCloseSnackBar(1)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={5000}
      >
        <Alert
          onClose={() => handleCloseSnackBar(1)}
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Notification error
        </Alert>
      </Snackbar>
    </>
  );
};

function schemaHasClient<T extends Entity>(
  schema: Schema<T>
): schema is SchemaWithClient<T> {
  return 'client' in schema;
}
